if (!customElements.get('chair-quantity-shortcuts')) {
  customElements.define('chair-quantity-shortcuts', class extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('product-info');
      if (!this.scope) return;
      this.onInput = () => this.sync();
      this.onClick = (event) => {
        const button = event.target.closest('button');
        const input = this.scope.querySelector('input[name="quantity"]');
        if (!button || !this.contains(button) || !input || button.disabled) return;
        if (button.hasAttribute('data-custom')) { input.focus(); input.select(); return; }
        input.value = button.dataset.quantity;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
        this.sync();
      };
      this.addEventListener('click', this.onClick);
      this.scope.addEventListener('input', this.onInput);
      this.scope.addEventListener('change', this.onInput);
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this.scope, { childList: true, subtree: true, attributes: true, attributeFilter: ['min', 'max', 'step', 'disabled'] });
      this.sync();
    }
    sync() {
      const input = this.scope.querySelector('input[name="quantity"]');
      this.hidden = !input;
      if (!input) return;
      const min = Number(input.min || 1), max = input.max ? Number(input.max) : Infinity, step = Number(input.step || 1);
      const value = Number(input.value);
      let selected = false;
      for (const button of this.querySelectorAll('[data-quantity]')) {
        const quantity = Number(button.dataset.quantity);
        const disabled = input.disabled || quantity < min || quantity > max || (quantity - min) % step !== 0;
        if (button.disabled !== disabled) button.disabled = disabled;
        const active = !disabled && quantity === value;
        button.setAttribute('aria-pressed', String(active));
        selected ||= active;
      }
      this.querySelector('[data-custom]').setAttribute('aria-pressed', String(!selected));
      const summary = this.querySelector('.chair-quantity-shortcuts__summary');
      const text = input.value && input.checkValidity() ? `${value} ${value === 1 ? 'chair' : 'chairs'} selected` : 'Enter a valid chair quantity';
      if (summary.textContent !== text) summary.textContent = text;
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.scope?.removeEventListener('input', this.onInput);
      this.scope?.removeEventListener('change', this.onInput);
      this.observer?.disconnect();
    }
  });
}
